import { createStore, applyMiddleware, compose } from "redux";
import reducers from "../reducers";
import get from "lodash/get";

const middleware = [];
const composeEnhancers = get(window, "__REDUX_DEVTOOLS_EXTENSION_COMPOSE__", compose);

export const configureStore = initialState => createStore(
  reducers,
  initialState,
  composeEnhancers(
    applyMiddleware(...middleware)
  )
);



// WEBPACK FOOTER //
// ./src/redux/store/index.js